<template>
  <section class="form-surface">
    <div class="form-panel">
      <h1>Not found</h1>
      <RouterLink class="app-link" to="/">Go home</RouterLink>
    </div>
  </section>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
</script>
